// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2Q4hQ","footer":"ModalUpdate_footer__1jz5v"};